import Login from "../Landing/pages/Login/Login";
import Logout from "../Landing/pages/Logout";
import RoutesNames from "../Services/RoutesNames";
import AnonymousRouteProvider from "./RouteProvider/AnonymousRouteProvider";

const AuthRoutes = [
    {
        element: <AnonymousRouteProvider />,
        children: [
            {
                path: RoutesNames.Login,
                element: <Login />,
            },
            {
                path: "/",
                element: <Login />,
            },
            {
                path: RoutesNames.SilentLogin,
                element: <Login />,
            },
        ],
    },
    {
        path: "/logout",
        element: <Logout />,
    },
];

export default AuthRoutes;
